import { useNavigate } from "react-router-dom";

import { trackEvent } from "@lib/infrastructure";
import { HaNContext, HaNSearchContext, type HaNSearchCategoryResult, HaNViewStoreContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { useHaNTabLinkSearch } from "../data/useHaNBuilding";
import { useConfirmDiscardingBooking } from "../details/useConfirmDiscardingBooking";

type ResultListPlace = { position: number; resultCount: number };

export const useOpenSearchCategory = () => {
  const navigate = useNavigate();
  const tabLinkSearch = useHaNTabLinkSearch();
  const { tab, building } = useRequiredContext(HaNContext);
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const { settledQuery, setQuery } = useRequiredContext(HaNSearchContext);
  const confirmDiscardingBooking = useConfirmDiscardingBooking();

  return (result: HaNSearchCategoryResult, listPlace: ResultListPlace) => {
    confirmDiscardingBooking(() => {
      viewStore.selectFacilityCategory(result.category.id);

      // The results would cover the category's list
      setQuery("");

      if (tab !== "facilities") {
        navigate({ pathname: "/now/facilities", search: tabLinkSearch });
      }

      trackEvent("HereAndNow_Search__ResultClick", {
        buildingId: building.buildingId ?? "",
        tab,
        kind: "category",
        match: result.match,
        isInBuilding: true,
        isOnOtherFloor: false,
        queryLength: settledQuery.length,
        isExpanded: false,
        ...listPlace,
      });
    });
  };
};
